// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__PjEBI","error":"Textarea_error__2_aB6","readonly":"Textarea_readonly__2cX9K","disabled":"Textarea_disabled__M8rfQ"};